import { Component, Input, OnInit } from '@angular/core';
import AOS from 'aos'

@Component({
  selector: 'app-carta-img-izq',
  templateUrl: './carta-img-izq.component.html',
  styleUrls: ['./carta-img-izq.component.css']
})
export class CartaImgIzqComponent implements OnInit {

  @Input() imagen: string
  @Input() descripcion: string
  @Input() imgTamano: number

  ngOnInit(): void {
    AOS.init({ once: true });

  }

}
